import "./Footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2025 Bookmarkd. All Rights Reserved.</p>
        <p>Track, discover, and share your reading journey</p>
      </div>
    </footer>
  )
}

export default Footer
